import { Component, OnInit, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import { LocalStorage, MenuItemsAccess } from 'src/app/appCommon/Enums/enum';
import { AnalyzeService } from 'src/app/appServices/AnalyzeService/analyzeService.service';
import { PiteamService } from 'src/app/appServices/DefineService/piTeam-service';
import { HelperService } from 'src/app/appServices/HelperService/helper.service';
import { ToasterService } from 'src/app/appServices/ToasterService/toaster.service';
import * as FileSaver from 'file-saver'; // FOR SAVING EXCEL FILE
import { Workbook } from 'exceljs';
import { Subscription } from 'rxjs';
import { object, userTypeOptions } from '../../../../shared/shared';
import { AccessControlService } from 'src/app/appServices/CommonService/access-control.service';
import { alreadyAssignedFac, facilitySystemList, roleList, roleSubmitData } from 'src/app/appWeb/shared/shared-interface';
import { AuthService } from 'src/app/appServices/AuthService/auth.service';

@Component({
  selector: 'app-create-roles',
  templateUrl: './create-roles.component.html',
  styleUrls: ['./create-roles.component.scss']
})
export class CreateRolesComponent implements OnInit {
  @ViewChild('dt') dt: Table | undefined;
  rolesList: Array<roleList> = [];
  totalRecords:number = 0;
  pageNumber:number = 1;
  rows:number = 15;
  sortOrder:string = "Asc";
  sortCol:string = "";
  filterVal:string = "";
  UId: string | null = '';
  UName: string | null = '';
  RoleIds: Array<string> = [];
  assignedRoles: Array<roleList> = [];
  showProgressSpinner: boolean = false;
  noRecordBool:boolean = false;
  cols: any;
  roleSubmitData!: roleSubmitData;
  textAreaOtherBool: boolean = false;
  title: Array<string> = [];
  IsChange: Array<boolean> = [];
  loading: Array<boolean> = [];
  indOffAssObj: number = 0;
  isAccessReadWrite!: boolean;
  roleAccessResult: Array<any> = [];
  RoleName: string = '';  
  facilityList: Array<facilitySystemList> = [];
  systemList: Array<facilitySystemList> = [];
  selectedFacility: Array<string> = [];
  selectedSystem: Array<string> = [];
  systemListTemp:Array<facilitySystemList> = [];
  userTypeOptions = userTypeOptions;
  selectedUserType:string = '';
  totalAssignedFac:number = 0;
  alreadyAssignedFac:Array<alreadyAssignedFac> = [];
  showAlreadyFacBool:boolean = true;
  indexForAssign!: number;
  showTotalAssignFacBool: boolean = true;
  roleAssign:any;
  totalAssignedFacNo: number = 0;
  showTotalAssignFacNoBool:boolean = false;
  alreadyAssignedFacLengthBool:boolean = false;
  facilityListTemp: Array<facilitySystemList> =[];
  roleTitleName: string = '';
  assignedRolesTemp: Array<any> = [];
  exportExcelLoader: boolean = false;
  data:any = {};
  assignClicked: boolean = false; 
  private subscription: Subscription[] = [];
  roleForFacility: boolean = false;
  crossSearchBool: boolean = false;

  constructor(
    public PiTeamService: PiteamService,
    private toastService: ToasterService,
    public messageService: MessageService,
    private helperService: HelperService,
    private analyzeService: AnalyzeService,
    private accessControlService: AccessControlService,
    private authService: AuthService
    
  ) { }

  ngOnInit(): void {
    this.UId = this.helperService.decryption(localStorage.getItem(LocalStorage.UId));
    this.UName = this.helperService.decryption(localStorage.getItem(LocalStorage.UName));
    this.RoleName = this.helperService.decryption(localStorage.getItem(LocalStorage.UserRoleName));
    this.roleForFacility = this.authService.roleForFacility();
    // this.getAllValuesOfFilter();
  }


  onChangeReportType(event: any, index: any) {
    let ind =  index -((this.rows * this.pageNumber) - this.rows);
    let title = this.userTypeOptions.filter((x:any)=>{return x.value == event.value});
    if(this.assignedRolesTemp[ind].RoleTitle == title[0].name){
      this.IsChange[index] = true;
    }else{
      this.IsChange[index] = false;
    }
  }
  // getAllValuesOfFilter() {
  //   this.subscription.push(
  //   this.analyzeService.GetFacilityPIList(this.RoleName,this.UId).subscribe({
  //     next: (res: any) => {
  //       if (res) {
  //         this.facilityList = res.Facilities;
  //         this.facilityListTemp = res.Facilities;
  //         this.systemList = res.systemList;
  //         this.systemListTemp = res.systemList;
  //       }
  //     },
  //     error: (err: any) => { },
  //   })
  //   );
  // }
  GetAllData(val:string){
    if((this.facilityList.length === 0 && val == 'facility') || 
    (this.systemList.length === 0 && val == 'system')){
      this.showProgressSpinner = true;
    let obj = object;
    if(val == 'system'){
      obj.FieldName = 'ucd_ucl_key';
      obj.Value = '42';
    }else
    {
      obj.FieldName = 'facility';
      obj.Value = 'facility';
    }
    this.subscription.push(
      this.analyzeService.GetAllData(obj,this.RoleName,this.UId).subscribe({
        next: (res: any) => {
          if (res) {
            this.showProgressSpinner = false;
            if(val == 'system'){
              this.systemList = res.data;
              this.systemListTemp = res.data;
            }else{
              this.facilityList = res.data;
              this.facilityListTemp = res.data;
            }
          }
        },
        error: (err: any) => { },
      })
      );
    }
  }
  GetUsersWithRoles() {
    this.assignedRolesTemp = [];
    this.showProgressSpinner = true;
    let data = {
      Take: this.rows,
      Skip: (this.rows * this.pageNumber) - this.rows,
      Sort:
      {
        FieldName: this.sortCol,
        Order: this.sortOrder
      },
      Filters: [
          {
            FieldName: 'facilityIDs',
            value: this.selectedFacility.join(',')
          },
        ],
      Filter: {
        field: "",
        operator: "",
        value: this.filterVal,
        logic: "",
        filters: [],
      },
      searchString: this.filterVal,
      PageNumber: this.pageNumber,
      serviceType: [],
      roleIDs: [this.selectedUserType.toString()],
    }
    this.data = data;
    this.subscription.push(
    this.PiTeamService.GetUsersWithRoles(data, this.selectedSystem, this.RoleName, this.UId).subscribe({
      next: (res: any) => {
        let abc = res.assignedRoles;
        abc.forEach((element: any) => {
          let Akeys = Object.keys(element);
        for (let key of Akeys) {
          if(key == 'RoleTitle'){
          this.assignedRolesTemp.push({RoleTitle: element[key]})
          }
        }
        });
        this.title = res.Title;
        if (res.assignedRoles.length == 0) { this.noRecordBool = true; }
        else { this.noRecordBool = false; }
        if (res) {
          this.assignedRoles = res.assignedRoles;
          this.rolesList = res.AllRoles;

          for (let index = 0; index < this.assignedRoles.length; index++) {
            // this.assignedRoles[index].RoleId = this.assignedRoles[index].RoleId.split(',');
            const roleId = this.assignedRoles[index].RoleId;
            if (roleId !== null) {
              this.assignedRoles[index].RoleId = roleId.split(',') as unknown as string;
            }
          }
          this.assignedRoles.forEach((item:any)=>{
            let Status = this.userTypeOptions.filter((x: any) => { return x.name == item.RoleTitle }); 
            if(Status.length > 0){
              item.RoleTitle = Status[0].value;
            } 
          })
          this.totalRecords = res.Total ? res.Total : 0;
          this.showProgressSpinner = false;
          this.PiTeamService.currentDateTime();

          const accessData = this.accessControlService.checkAccess( MenuItemsAccess.RolesAssignmentRead, MenuItemsAccess.RolesAssignmentReadWrite);
          this.isAccessReadWrite = accessData.isAccessReadWrite;

        }
      },
      error: (err: any) => { },
    })
    );
  }

  applyFilterGlobal($event: any, stringVal: string) {
    const inputValue = ($event.target as HTMLInputElement).value;
    this.dt!.filterGlobal(inputValue, stringVal);
    if(inputValue !== ''){
      this.crossSearchBool = true;
    }else{
    this.crossSearchBool = false;
    }
  }
  clearSearchField() {
    this.crossSearchBool = false;
    this.filterVal = '';
    this.GetUsersWithRoles();
   
  }

  lazyLoadSchedules(event: any) {
    if (event != undefined) {
      this.rows = event.rows;
      this.pageNumber = (event.first / this.rows) + 1;
      this.sortOrder = (event.multiSortMeta == undefined || event.multiSortMeta[0].order == 1) ? 'ASC' : 'DESC';
      this.sortCol = (event.multiSortMeta == undefined) ? '' : event.multiSortMeta[0].field;
      this.filterVal = event.filters.global == undefined ? '' : event.filters.global.value;
      this.GetUsersWithRoles();
    }
  }
  
  GetAssignedFacilityInfo(data: any, index: number) {
    this.indexForAssign = index;
    this.loading[index] = true;
    this.roleSubmitData = data;
    this.indOffAssObj = index;
    this.RoleIds = [];
    let errStr = "No Role selected for " + this.roleSubmitData.UserName;
    if (this.roleSubmitData.RoleId!.length > 0) {
      for (let index = 0; index < this.roleSubmitData.RoleId!.length; index++) {
        this.RoleIds.push(this.roleSubmitData.RoleId![index]
        );
      }

      let roleTitle: any;
      roleTitle =  this.userTypeOptions.filter((element: any) => {
        return element.value == this.roleSubmitData.RoleTitle
      });

      let columnNames :any = null;
      if(roleTitle.length > 0){
      columnNames = roleTitle[0]?.value.split(';');
      this.roleTitleName = roleTitle[0].name;
      }

      this.roleAssign = {
        RoleId : this.RoleIds,
        userId : this.roleSubmitData.UserId,
        RoleTitle : roleTitle.length > 0 ? roleTitle[0].name : null,
        crntColumnEmail : columnNames == null ? null : columnNames[0],
        crntColumnName : columnNames == null ? null : columnNames[1],
        crntColumnPhone : columnNames ==null ? null : columnNames[2],
        titleEmail :  this.roleSubmitData.Email,
        titleName : this.roleSubmitData.UserName,
        titlePhone : this.roleSubmitData.MobilePhone,
        fac_key : '',
        fac_address : '',
        fac_city : '',
        fac_code : '',
        fac_state : ''
      }
      if(columnNames != null){

      this.showProgressSpinner = true;
      this.subscription.push(
      this.PiTeamService.GetAssignedFacilityInfo(this.roleAssign).subscribe({
        next: (res: any) => {
          this.totalAssignedFac = res.allAssigned;
          this.alreadyAssignedFac = res.alreadyAssigned;
          var alreadyAssignedFac = res.alreadyAssigned.length;
          if(this.alreadyAssignedFac.length > 0){
            if(this.alreadyAssignedFac[0].qms_user_role_title != null){
              let resRoleTitle =  this.userTypeOptions.filter((element: any) => {
                return element.name == this.alreadyAssignedFac[0].qms_user_role_title
              });
              this.roleAssign.prevColumnEmail = resRoleTitle[0]?.value?.split(';')[0]
              this.roleAssign.prevColumnName = resRoleTitle[0]?.value?.split(';')[1]
              this.roleAssign.prevColumnPhone = resRoleTitle[0]?.value?.split(';')[2]
            }else{
              this.roleAssign.prevColumnEmail = null
              this.roleAssign.prevColumnName =  null
              this.roleAssign.prevColumnPhone = null
            }
          }
          
          if(this.alreadyAssignedFac.length == 0){
            this.alreadyAssignedFacLengthBool = true;
          }else{
            this.alreadyAssignedFacLengthBool = false;
          }
          if(this.totalAssignedFac == 0){
            this.showAlreadyFacBool = false;
          }else{
            this.showAlreadyFacBool = true;
          }
          if(this.totalAssignedFac == 1 && this.alreadyAssignedFac.length == 1){
            this.showTotalAssignFacBool = false;
          }else{
            this.showTotalAssignFacBool = true;
          }
          if(this.totalAssignedFac == alreadyAssignedFac){

            this.showTotalAssignFacBool = false;
          }else{
            this.showTotalAssignFacBool = true;
          }
          if(this.alreadyAssignedFac.length > 5){
            this.showTotalAssignFacNoBool = true;
            this.totalAssignedFacNo = this.alreadyAssignedFac.length - 5;
            this.alreadyAssignedFac = this.alreadyAssignedFac.slice(0,5);
          }else{
            this.showTotalAssignFacNoBool = false;
          }
          this.textAreaOtherBool = true;
        
          this.showProgressSpinner = false;
          this.loading[this.indOffAssObj] = false;
          this.IsChange[this.indOffAssObj] = true;
        },
      })
      );
    }
    else{
      this.assign();
    }
    } else {
      this.loading[index] = false;
      this.toastService.customErr(errStr);
    }
  }
  assign() {
      this.showProgressSpinner = true;
      this.subscription.push(
      this.PiTeamService.AssignRole(this.roleAssign).subscribe({
        next: (res: any) => {
          let ind =  this.indexForAssign -((this.rows * this.pageNumber) - this.rows);
          this.assignedRolesTemp[ind].RoleTitle = this.roleAssign.RoleTitle;
          this.loading[this.indexForAssign] = false;
          this.IsChange[this.indexForAssign] = true;
          this.assignClicked = true;
          this.textAreaOtherBool = false;
          this.toastService.message("Role Added Successfuly.");
          this.showProgressSpinner = false;
          
        },
      })
      );
  }

  onReject() {
    this.messageService.clear();
    this.loading[this.indOffAssObj] = false;
    this.IsChange[this.indOffAssObj] = true;
  }

  canceltextarea(event: Event, val:string) {
    if(event && event.type === 'click' || val == 'Cancel' && this.assignClicked == false ){
      this.textAreaOtherBool = false;
      this.IsChange[this.indOffAssObj] = false;
      this.assignClicked = false;
    }else{
      this.textAreaOtherBool = false;
      this.IsChange[this.indOffAssObj] = true;
    }
    
  }
  
  CheckChange(index: number){
    // if(this.assignedRoles?.RoleTitle?.length > 0){
    // }
    this.IsChange[index] = false
  }
  GetFacility(){
    if(this.selectedSystem.length > 0){
      this.subscription.push(
      this.analyzeService.GetFacilityBySystem(this.selectedSystem).subscribe({
        next: (res: any) => {
          if(res){
            this.facilityList = res.data.data;
            this.GetUsersWithRoles();
          }
        },
        error: (err: any) => { 
        },
      })
      );
    }else{
      this.systemList = this.systemListTemp;
      this.facilityList = [];
      this.selectedFacility = [];
      this.facilityList = this.facilityListTemp;
      this.GetUsersWithRoles();
    }
  }

  OnMultiSelectChange(){
    this.GetUsersWithRoles();
  }

  excelDownload(workbook: any, fileName: any) {
    workbook.xlsx.writeBuffer().then((data: any) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      FileSaver.saveAs(blob, fileName + '.xlsx');
    })
  }

  exportExcel() {
    this.exportExcelLoader = true;
    let newArray: any = [];
    let roleList: any = [];
    let assignedRoles:any=  [];
    let tempArr:any = [];
    this.data.Take = 0;
    this.data.Skip = 0;
    this.subscription.push(
    this.PiTeamService.GetUsersWithRoles(this.data, this.selectedSystem, this.RoleName, this.UId).subscribe({
      next: (res: any) => {
        if (res) {
          assignedRoles = res.assignedRoles;
          roleList = res.AllRoles;
          if(assignedRoles.length > 0){
            assignedRoles.forEach((item:any)=>{
                let Status = this.userTypeOptions.filter((x: any) => { return x.name == item.RoleTitle }); 
                if(Status.length > 0){
                  item.RoleTitle = Status[0].name;
                }else{
                  item.RoleTitle = '';
                } 
              if(item.RoleId){
                item.RoleId = item.RoleId.split(',');
                roleList.forEach((i:any)=>{
                  const obj2 = item.RoleId.find((o:any) => o === i.RoleId);
                  if (obj2) {
                    tempArr.push(i.RoleName)
                  }
                })
                item.RoleId = tempArr.join();
                tempArr = [];
              }
                newArray.push({UserName: item.UserName,FirstName: item.FirstName,LastName: item.LastName,
                  MobilePhone: item.MobilePhone ,Email: item.Email,RoleId: item.RoleId,RoleTitle: item.RoleTitle});
            })
          }

          let dataForExcel: any = [];
          let workbook = new Workbook();
          let worksheet = workbook.addWorksheet('Sheet1', { properties: { tabColor: { argb: '36286B' }, outlineLevelRow: 1 } });
          worksheet.columns = [
            { header: 'User Name', key: 'Username', width: 25 },
            { header: 'First Name', key: 'First Name ', width: 25 },
            { header: 'Last Name', key: 'Last Name', width: 25 },
            { header: 'Phone', key: 'Phone', width: 20 },
            { header: 'Email', key: 'Email', width: 25 },
            { header: 'TeleCare User Type', key: 'TeleCare User Type', width: 60 },
            { header: 'Facility Role', key: 'Facility Role', width: 25 }
          ]
          worksheet.eachRow({ includeEmpty: true }, function (row, rowNumber) {
            row.eachCell((cell, number) => {
              cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '767C88' },
                bgColor: { argb: '' },
    
              }
              cell.font = {
                bold: true,
                color: { argb: 'FFFFFF' },
                size: 12,
              }
            })
          })
          newArray.forEach((element: any) => {
            dataForExcel.push(Object.values(element))
          });
    
          dataForExcel.forEach((d: any) => {
            let row = worksheet.addRow(d);
          })
          this.excelDownload(workbook, "Roles Assignment");
          this.exportExcelLoader = false;
        }
      },
      error: (err: any) => { },
    })
    );
    
  }
  load(index: number) {
    this.loading[index] = true;
    setTimeout(() => (this.loading[index] = false), 1000);
  }


  ngOnDestroy() {
    if(this.subscription.length != 0){
      this.subscription.forEach((i:any)=>{
        i.unsubscribe();
      })
    }
    
    Object.getOwnPropertyNames(this)
      .filter(propName => Array.isArray((<any>this)[propName]))
      .forEach(propName => (<any>this)[propName] = []);
  }

}
